import React from "react";
import styles from "../../styles/components/common/RouteAuthGate.module.css";

const RouteAuthGate = ({ label = "Loading..." }) => (
  <div className="pageContainer">
    <div className="innerContainer">
      <div className={styles.gate} aria-busy="true" aria-label={label}>
        <div className={styles.pulseBlock} />
        <div className={styles.pulseBlockWide} />
        <div className={styles.pulseBlock} />
      </div>
    </div>
  </div>
);

export default RouteAuthGate;
